import { render, staticRenderFns } from "./tutorials.vue?vue&type=template&id=a23a05c4&scoped=true"
import script from "./tutorials.vue?vue&type=script&lang=js"
export * from "./tutorials.vue?vue&type=script&lang=js"
import style0 from "./tutorials.vue?vue&type=style&index=0&id=a23a05c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23a05c4",
  null
  
)

export default component.exports